import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import Select from 'react-select';
import StudentAssessmentForm from 'containers/Forms/StudentAssessmentFormV1';
import Modal from 'containers/Modals/Modal';
/**
 * @param {string} props name - Input name
 * @param {string} props id - Input id
 * @param {Array<value, label, disabled, color>} props options
 * @param {function} props onChange
 *
 * @returns {JSX Component}
 */

var StudentAssessorSelect = /*#__PURE__*/function (_Component) {
  _inherits(StudentAssessorSelect, _Component);

  var _super = _createSuper(StudentAssessorSelect);

  function StudentAssessorSelect(props) {
    var _this;

    _classCallCheck(this, StudentAssessorSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (newProps) {
      if (newProps.defaultValue !== _this.props.defaultValue) {
        _this.setState({
          value: newProps.defaultValue
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onChange", function (option, item) {
      _this.setState({
        value: option.value
      });

      _this.props.onChange(option.value, item);
    });

    _defineProperty(_assertThisInitialized(_this), "showStudentAssessmentModal", function () {
      _this.setState({
        studentAssessmentModalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideStudentAssessmentModal", function () {
      _this.setState({
        studentAssessmentModalIsOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentAssessmentSubmit", function () {
      _this.setState({
        studentAssessmentModalIsOpen: false
      });
    });

    _this.state = {
      value: _this.props.defaultValue ? _this.props.defaultValue : null,
      disabled: _this.props.disabled != null ? _this.props.disabled : false,
      studentAssessmentModalIsOpen: false
    };
    return _this;
  }

  _createClass(StudentAssessorSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var options = this.props.options.map(function (assessor) {
        if (assessor != undefined) {
          if (assessor.id != _this2.props.item.id) {
            var obj = {
              value: assessor.assignedTo,
              label: /*#__PURE__*/React.createElement("span", {
                className: "simple-select__label"
              }, assessor.groupName)
            };
            return obj;
          }
        }
      });
      options = options.filter(function (option) {
        return option != undefined;
      });
      var value = options.find(function (option) {
        return option.value == _this2.state.value;
      });
      return this.props.item.isStudentAssessed ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.studentAssessmentModalIsOpen,
        onClose: this.hideStudentAssessmentModal,
        title: this.props.translate('buddy-assessment')
      }, /*#__PURE__*/React.createElement(StudentAssessmentForm, {
        item: this.props.item,
        items: this.props.options,
        knowledgeBlocks: this.props.planningBlocks,
        referenceType: "assigments",
        statuses: this.state.statusOptions,
        onStatusChange: this.onAssessmentStatusChange,
        onSubmit: this.onStudentAssessmentSubmit,
        onAbort: this.hideStudentAssessmentModal,
        teacher: true,
        section: this.props.section
      })), /*#__PURE__*/React.createElement("span", {
        className: "button button-target",
        onClick: function onClick() {
          _this2.showStudentAssessmentModal();
        }
      }, this.props.translate('show-assessment'))) : /*#__PURE__*/React.createElement(Select, {
        isDisabled: this.state.disabled,
        isSearchable: false,
        isClearable: false,
        name: "studentAssesosr",
        value: value,
        options: options,
        onChange: function onChange(event) {
          return _this2._onChange(event, _this2.props.item);
        },
        className: "simple-select",
        placeholder: this.props.placeholder != null ? this.props.placeholder : ''
      });
    }
  }]);

  return StudentAssessorSelect;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {})(StudentAssessorSelect);